/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

$(document).ready(function () {
  /* Newsletter Pop-Up */

  if ($('#Newsletter__Form-input').length) {
    var $newsletterForm = $('#newsletter-popup'),
        $newsletterInput = $('#Newsletter__Form-input'),
        $newsletterSubmit = $newsletterForm.find('.Form__Submit'),
        $newsletterCheck = $newsletterForm.find('.Newsletter__Form-check'),
        $newsletterConfirm = $newsletterForm.find('.Newsletter__Alert--success'),
        $newsletterError = $newsletterForm.find('.Newsletter__Alert--error'),
        $newsletterAlreadySubscribed = $newsletterForm.find('.Newsletter__AlreadySubscribed');

    $newsletterInput.on('change keyup', function() {
     if ($newsletterInput.val()) {
       $newsletterSubmit.removeClass('Hidden')
       $newsletterError.addClass('Hidden')
     } else {
       $newsletterSubmit.addClass('Hidden')
     }

    });

    $newsletterForm.on('submit', function (e) {
      e.preventDefault()
      e.stopPropagation()
      e.stopImmediatePropagation()
      console.log('submit custom')
      var form = $(this);
      var mailformat = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
      var email = form.find('input[type="email"]').val();
      var klaviyoListId = form.find('input[type="email"]').data('klaviyo-list-id');
      var origin = '';
      // var data = {
      //   'g': klaviyoListId,
      //   '$fields': '$source,$email,$consent_method,$origin',
      //   '$list_fields': '',
      //   '$timezone_offset': Math.abs(new Date().getTimezoneOffset() / 60),
      //   'SignUpDate': Math.abs(new Date().getTimezoneOffset() / 60),
      //   '$title': 'Sign up from pop-up',
      //   '$source': 'Pop-up',
      //   '$email': email,
      //   '$consent_method': 'Klaviyo Form',
      //   '$origin': origin
      // };
      // var data = {
      //   type: 'subscription',
      //   attributes: {
      //     custom_source: 'Sign up from pop-up',
      //     profile: {
      //       data: {
      //         type: 'profile',
      //         attributes: {
      //           email: email
      //         }
      //       }
      //     }
      //   },
      //   relationships: {list: {data: {type: 'list', id: klaviyoListId}}}
      // };

      // $.ajax({
      //   method: 'POST',
      //   headers: {revision: '2024-05-15', 'content-type': 'application/json'},
      //   url: 'https://a.klaviyo.com/client/subscriptions/?company_id=NNXjVm',
      //   data: data
      // }).done(function (response) {
      //   if (response.success) {
      //     $newsletterCheck.removeClass('Hidden');
      //     if (response.data.is_subscribed) {
      //       setTimeout(function () {
      //         $newsletterCheck.addClass('Hidden');
      //         form.find('#Newsletter__Form-input').addClass('Hidden')
      //         form.find('.Form__Submit').addClass('Hidden')
      //         $newsletterAlreadySubscribed.removeClass('Hidden');
      //       }, 2000);
      //     } else {
      //       setTimeout(function () {
      //         $newsletterCheck.addClass('Hidden');
      //         $newsletterConfirm.removeClass('Hidden');
      //         form.find('#Newsletter__Form-input').addClass('Hidden')
      //         form.find('.Form__Submit').addClass('Hidden')
      //       }, 2000);
      //     }
      //   }
      // }).fail(function () {
      //   form.find('.Newsletter__Alert--error').removeClass('Hidden')
      // });

      const options = {
        method: 'POST',
        headers: {revision: '2024-05-15', 'content-type': 'application/json'},
        body: JSON.stringify({
          data: {
            type: 'subscription',
            attributes: {
              custom_source: 'Sign up from pop-up',
              profile: {
                data: {
                  type: 'profile',
                  attributes: {
                    email: email
                  }
                }
              }
            },
            relationships: {list: {data: {type: 'list', id: klaviyoListId}}}
          }
        })
      };


      if (email.match(mailformat) && klaviyoListId.length > 2) {
        fetch(`https://a.klaviyo.com/client/subscriptions/?company_id=NNXjVm`, options)
          .then(response => {
            if(response.status === 202) {
              $newsletterCheck.removeClass('Hidden');
              setTimeout(function () {
                $newsletterCheck.addClass('Hidden');
                $newsletterConfirm.removeClass('Hidden');
                form.find('#Newsletter__Form-input').addClass('Hidden')
                form.find('.Form__Submit').addClass('Hidden')
              }, 2000);
            } else {
              form.find('.Newsletter__Alert--error').removeClass('Hidden')
            }
          })
          .catch(err => console.error(err));
      }
    });
  }

  /* Header */

  $(document).on("click", "[aria-haspopup='true'] .HorizontalList__Item-MegaMenu-link", function (e) {
    // e.preventDefault()
  });

  /* Footer */

  function openFooter(footerHeader) {
    var scrollTo = footerHeader.parents('.Footer').offset().top;
    footerHeader.parents('.Footer').find('.Footer__Collapsible-Content').slideToggle(400, function () {
      if ($('.Footer__Collapsible-Content:not(:visible)')) {
        if ($(window).width() > 1140) {
          $("html, body").animate({ scrollTop: $(document).height() }, 400);
        } else {
          $("html, body").animate({ scrollTop: scrollTo }, 400);
        }
      }
    })
    footerHeader.parents('.Footer').toggleClass('Footer--Open')
  }


  $('.Footer__Header').on('click', function () {
    openFooter($(this))
  })

  if ($('.Footer__Collapsible-Title').length) {
    $(window).resize(function () {
      if ($(window).width() > 640) {
        $('.Footer__links-Wrapper .Collapsible__Inner').removeAttr('style')
        $('.Footer__Collapsible-Title').attr('aria-expanded', 'false')
      }

    })
  }

  /* Mobile Pop-Up */

  $('.Global--Drawer-Swipe-Header').swipe( {

    swipe:function(event, direction, distance, duration, fingerCount, fingerData) {
      if (direction === 'down') {
        var Drawer = $(this).parents('.Drawer');
        var Overlay = $('.PageOverlay');
        if (event) { event.preventDefault(); }
        Drawer.attr('aria-hidden', 'true');

        if (!Drawer.parents('.Drawer').length) {
          document.documentElement.classList.remove('no-scroll');
          disableBodyScroll(false, '[data-scrollable]');
        }

        if (Drawer.find(('.Drawer__Close_All')).length !== 0) {
          Overlay.click();
          Overlay.removeClass('is-visible');
          Overlay.off('click', Drawer._closeListener);
        }
      }
    }
  });

  /* Collection landing */

  if ($('.collection-landing__hero-date-block').length) {
    var themeTextWidth = $('.collection-landing__hero-date-block-theme').outerWidth()
    $('.collection-landing__hero-date-block-theme').css('height', themeTextWidth)
  }

  /* Video play & pause button */

  $(document).on('click', '.mute-video', function () {
    let $videos = $(this).parent().find("video.landing__hero-video");
    if ($videos.length <= 0) return
    if ($videos.prop('muted')) {
      $videos.prop('muted', false);
      $(this).removeClass('unmute-video');
    } else {
      $videos.prop('muted', true);
      $(this).addClass('unmute-video');
    }
  });

  $(document).on('click', '.media-video', function () {
    let $videos = $(this).parent().find(".landing__hero-video");
    if (this.paused) {
      $videos.each(function () {$(this)[0].play()})
      $(this).parent().find(".play-button").fadeOut()
      if ($(this).parent().find(".pause-button").length) {
        $(this).parent().find(".pause-button").removeClass('hidden').fadeIn()
      }
    } else {
      $videos.each(function () {$(this)[0].pause()})
      $(this).parent().find(".play-button").removeClass('hidden').fadeIn()
      if ($(this).parent().find(".pause-button").length) {
        $(this).parent().find(".pause-button").fadeOut()
      }
    }
  });

  $(document).on('click', '.play-button', function () {
    let $videos = $(this).parent().find('.media-video');
    $videos.each(function () {$(this)[0].play()})
    $(this).parent().find(".play-button").fadeOut()
    if ($(this).parent().find(".pause-button").length) {
      $(this).parent().find(".pause-button").removeClass('hidden').fadeIn()
    }
  });

  $(document).on('click', '.pause-button', function () {
    let $videos = $(this).parent().find('.media-video');
    $videos.each(function () {$(this)[0].pause()})
    $(this).parent().find(".play-button").removeClass('hidden').fadeIn()
    $(this).parent().find(".pause-button").fadeOut()
  });

  /* Sliders */

  var $aboutSlider = $('.AboutSlider__Slider');
  if ($aboutSlider.length) {
      var $sliderNav = $aboutSlider;
      var $sliderFor = $('.AboutSlider__ContentSlider');
      var $controlsLeft = $('.AboutSlider__Controls--Left');
      var $controlsRight = $('.AboutSlider__Controls--Right');
      var $progressBar = $('.AboutSlider__Progress');
      recommendProductSlider($sliderFor, $sliderNav, 1, 1, 1, $controlsLeft, $controlsRight, $progressBar);
    }

  function aboutMobileSlider() {
    var $aboutMobileSlider = $('.AboutImagesBlocks__List')

    if ($(window).width() <= 768 && $aboutMobileSlider.length) {
      $aboutMobileSlider.not('.slick-initialized').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false,
        arrows: false,
        infinite: true
      });
    } else if ($(window).width() > 768 && $aboutMobileSlider.hasClass('slick-initialized')) {
      $aboutMobileSlider.slick('unslick');
    }
  }

  aboutMobileSlider();
  $(window).resize(aboutMobileSlider);

  function ourFavoriteSlider (slider, controlsLeft, controlsRight ) {
    slider.not('.slick-initialized').slick({
      slidesToShow: 2,
      slidesToScroll: 1,
      dots: false,
      prevArrow: controlsLeft,
      nextArrow: controlsRight,
      infinite: true,
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    });
  }

  function youMayLikeSlider (slider, controlsLeft, controlsRight ) {
    slider.not('.slick-initialized').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      dots: false,
      prevArrow: controlsLeft,
      nextArrow: controlsRight,
      infinite: true,
      responsive: [
        {
          breakpoint: 1280,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        }
      ]
    });
  }

  function cartProductSlider (slider, controlsLeft, controlsRight ) {
    slider.not('.slick-initialized').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: false,
      prevArrow: controlsLeft,
      nextArrow: controlsRight,
      infinite: true,
    });
  }

  function ourFavoriteSliderMobile (slider, progressBar, prevArrow, nextArrow) {
    slider.on('init', function(event, slick) {
      var calc = ( 100 / (slick.slideCount) );
      progressBar
          .css('background-size', calc + '% 100%')
          .attr('aria-valuenow', calc );
    });

    slider.not('.slick-initialized').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: false,
      prevArrow: prevArrow,
      nextArrow: nextArrow,
      infinite: false,
      autoplay: false
    });

    slider.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
      var calc = ( (nextSlide + 1) / (slick.slideCount) ) * 100;
      progressBar
          .css('background-size', calc + '% 100%')
          .attr('aria-valuenow', calc );
    });

    prevArrow.hide();
  }

  function staticSlideHeight() {
    var slideHeight = $('.our-favorite__slider.slick-initialized .product__card-link-image').outerHeight();
    $('.our-favorite__card-static .product__card-link').css('max-height', slideHeight)
  }

  if ($('.our-favorite__slider').length) {
    $('.our-favorite__slider').each(function () {
      var loopItem = $(this).data('forloop-item');
      var $slider = $('.our-favorite__slider-' + loopItem);
      var $controlsLeft = $('.our-favorite__content-controls-left');
      var $controlsRight = $('.our-favorite__content-controls-right');
      ourFavoriteSlider ($slider, $controlsLeft, $controlsRight);
    })
    staticSlideHeight()
    $(window).resize(function () {
      staticSlideHeight()
    });
  }

  if ($('.ProductCarouselList').length) {
    $('.ProductCarouselList').each(function () {
      var loopItem = $(this).data('forloop-item');
      var $slider = $('.ProductCarouselList');
      var $controlsLeft = $('.ProductCarouselList__Left');
      var $controlsRight = $('.ProductCarouselList__Right');
      cartProductSlider ($slider, $controlsLeft, $controlsRight);
    })
    staticSlideHeight()
    $(window).resize(function () {
      staticSlideHeight()
    });
  }

  if ($('.you-may-like__slider').length) {
    $('.you-may-like__slider').each(function () {
      var loopItem = $(this).data('forloop-item');
      var $slider = $('.you-may-like__slider-' + loopItem);
      var $controlsLeft = $('.you-may-like__slider-controls-left');
      var $controlsRight = $('.you-may-like__slider-controls-right');
      youMayLikeSlider ($slider, $controlsLeft, $controlsRight);
    })
    staticSlideHeight()
    $(window).resize(function () {
      staticSlideHeight()
    });
  }

  if ($('.our-favorite__slider-mobile').length) {
    $('.our-favorite__slider-mobile').each(function () {
      var loopItem = $(this).data('forloop-item-mobile');
      var $slider = $('.our-favorite__slider-mobile-' + loopItem);
      var $prevArrow = $('.our-favorite__content-controls-left-mobile-' + loopItem);
      var $nextArrow = $('.our-favorite__content-controls-right-mobile-' + loopItem);
      var $progressBar = $('.our-favorite__slider-mobile-progress-' + loopItem);
      ourFavoriteSliderMobile ($slider, $progressBar, $prevArrow, $nextArrow);
    })
  }

  if ($('.our-favorite__slider-landing').length) {
    $('.our-favorite__slider-landing').each(function () {
      var loopItem = $(this).data('forloop-item');
      var $slider = $('.our-favorite__slider-landing-' + loopItem);
      var $controlsLeft = $('.our-favorite__content-controls-left-' + loopItem);
      var $controlsRight = $('.our-favorite__content-controls-right-' + loopItem);
      ourFavoriteSlider ($slider, $controlsLeft, $controlsRight);
    })
    staticSlideHeight()
    $(window).resize(function () {
      staticSlideHeight()
    });
  }

  if ($('.our-favorite__slider-mobile-landing').length) {
    $('.our-favorite__slider-mobile-landing').each(function () {
      var loopItem = $(this).data('forloop-item-mobile');
      var $slider = $('.our-favorite__slider-mobile-landing-' + loopItem);
      var $prevArrow = $('.our-favorite__content-controls-left-mobile-' + loopItem);
      var $nextArrow = $('.our-favorite__content-controls-right-mobile-' + loopItem);
      var $progressBar = $('.our-favorite__slider-mobile-progress-' + loopItem);
      ourFavoriteSliderMobile ($slider, $progressBar, $prevArrow, $nextArrow)
    })
  }

  if ($('.collection-landing__images-slider').length) {
    var $collectionLandingImages = $('.collection-landing__images-slider');
    var centerMode = true;
    if ($('.collection-landing__images-slider-item').length > 2) {
      centerMode = false;
    }

    $collectionLandingImages.not('.slick-initialized').slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      dots: false,
      arrows: false,
      appendDots: $('.collection-landing__images-slider-dots'),
      infinite: true,
      centerMode: centerMode,
      centerPadding: '0',
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: true
          }
        }
      ]
    });
  }

  /* Product size selector */

  if ($('.Product').length || $('[data-section-type="collection"]').length) {
    var $thisProduct = $('.Product');

    if (!localStorage.getItem('hat-size') && window.location.href.indexOf("?variant=") >= 0 ) {
      var variant = window.location.href.split('?variant=')[1],
          selectedSize = $thisProduct.find('.no-js.ProductForm__Option option[value="' + variant + '"]').data('selected-size')?.toLowerCase(),
          $sizeSelector = $thisProduct.find('.SizeSwatchList .SizeSwatch__Radio[data-hat-size="' + selectedSize + '"]');
      if ($sizeSelector.length) {
        $sizeSelector.trigger('click')
        $thisProduct.find('.PseudoAddToCart').addClass('Hidden')
      }
    }

    function productSectionHeight() {
      var $productSection = $('.Product');
      var minHeight = $('.Product__Info ').outerHeight() + 600 + 'px';
      if ($productSection.data('product-type') !== 'Gift Card') {
        (window.innerWidth > 1008) ? $productSection.css('min-height', minHeight) : $productSection.css('min-height', 'auto');
      }
    }

    var $productStickyBar = $('.ProductStickyBar');

    function showPdpBar() {
      var elementPosition = $('.Product').outerHeight() + $('.Product').offset().top,
          formPosition = document.querySelector('.ProductForm').getBoundingClientRect();
          //footerPosition = $('#shopify-section-footer').offset().top;

      if ($(window).innerWidth() < 1008) {
        //(footerPosition < $(window).scrollTop() + $(window).innerHeight()) ? $('.Show').css('bottom', $(window).scrollTop() + $(window).innerHeight() - footerPosition) : $('.Show').css('bottom', 0);
        if (!$productStickyBar.hasClass('Show')) {
          $productStickyBar.addClass('Show')
        }
        if (formPosition.bottom - 100 < $(window).innerHeight() && formPosition.bottom + 60 > 0) {
          $productStickyBar.removeClass('Show')
        }
        $('body').css('marginBottom',$productStickyBar.outerHeight())
      } else {
        if ($(window).scrollTop() > elementPosition && !$productStickyBar.hasClass('Show')) {
          $productStickyBar.addClass('Show')
        } else if ($(window).scrollTop() < elementPosition && $productStickyBar.hasClass('Show')) {
          $productStickyBar.removeClass('Show')
        }
        $('body').css('marginBottom', 0)
      }
    }

    $('.ProductStickyBar__Photos').on('click', function () {
      $("html, body").animate({ scrollTop: 0 }, 600);
    })

    /* Out of stock notify */

    $(document).on('click', '.Notify__Btn:not([disabled])', function () {
        $('.Notify').addClass('Notify__Active');
    })

    $(document).on('click', '.Notify__StickyBar', function () {
      $("html, body").animate({ scrollTop: $('.Product__InfoWrapper').offset().top }, 600);
      $('.Notify__Btn').trigger('click')
    })

    $(document).on('submit', '.Notify__Wrapper', function (e) {
      e.preventDefault();
      var notifyInput = $('.Notify__Wrapper .Form__Input'),
          notify = $('.Notify'),
          email = notifyInput.val(),
          mesageBlock = $('.Notify__Message'),
          messageSuccess = notifyInput.attr('data-success'),
          messageError = notifyInput.attr('data-error'),
          variantId = notifyInput.attr('data-variant'),
          productId = notifyInput.attr('data-product');
      // var klaviyoData = {
      //   'a': 'NNXjVm',
      //   'q': '',
      //   'email': email,
      //   'variant': variantId,
      //   'product': productId,
      //   'platform': 'shopify',
      //   'subscribe_for_newsletter': false
      // };
      //
      //
      // $.ajax({
      //   method: 'POST',
      //   url: 'https://a.klaviyo.com/onsite/components/back-in-stock/subscribe',
      //   data: klaviyoData
      // }).done(function (response) {
      //   if (response.success) {
      //     mesageBlock.text(messageSuccess)
      //     notify.removeClass('Notify__Active')
      //     notify.addClass('Notify__MessageActive')
      //   } else {
      //     mesageBlock.text(messageError)
      //     notify.removeClass('Notify__Active')
      //     notify.addClass('Notify__MessageActive')
      //     console.error('Error Klaviyo: ', response.errors);
      //   }
      // }).fail(function (err) {
      //   mesageBlock.text(messageError)
      //   notify.removeClass('Notify__Active')
      //   notify.addClass('Notify__MessageActive')
      // });

      const options = {
        method: 'POST',
        headers: {revision: '2024-05-15', 'content-type': 'application/json'},
        body: JSON.stringify({
          data: {
            type: 'back-in-stock-subscription',
            attributes: {
              profile: {
                data: {
                  type: 'profile',
                  attributes: {
                    email: email
                  }
                }
              },
              channels: ['EMAIL'],
            },
            relationships: {
              variant: {
                data: {
                  type: 'catalog-variant',
                  id: `$shopify:::$default:::${variantId}`
                }
              }
            }
          }
        })
      };

      fetch(`https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=NNXjVm`, options)
        .then(response => {
          if(response.status === 202) {
            mesageBlock.text(messageSuccess)
            notify.removeClass('Notify__Active')
            notify.addClass('Notify__MessageActive')
          } else {
            mesageBlock.text(messageError)
            notify.removeClass('Notify__Active')
            notify.addClass('Notify__MessageActive')
            console.error('Error Klaviyo: ', response.errors);
          }
        })
        .catch(err => console.error(err));
    })

    $(document).on("click", function(e) {
      if (!$(e.target).closest('.Notify__Active').length) {
        $(".Notify").removeClass('Notify__Active');
      }
    });

    /* Color Swatch Hover */

    $(document).on('mouseenter', '.ColorSwatch', function () {
      var $colorSwatchValue = $('.ColorSwatch__Value');
      var colorItem = $(this).data('tooltip')
      $colorSwatchValue.text(colorItem)
    })

    $(document).on('mouseleave', '.ColorSwatch', function () {
      var $colorSwatchValue = $('.ColorSwatch__Value');
      // For metafield-based swatches, get the current product's color name
      var $currentColorSwatch = $('.ColorSwatch--current');
      if ($currentColorSwatch.length) {
        var currentColorName = $currentColorSwatch.data('tooltip');
        $colorSwatchValue.text(currentColorName);
      } else {
        // Fallback to original method for option-based swatches
        var $colorSwatchSelected = $('.Select option[selected]').data('selected-color');
        $colorSwatchValue.text($colorSwatchSelected);
      }
    })


    if ($('.Product').length) {
      productSectionHeight();
      $(window).resize(function () {
        productSectionHeight();
      });

      showPdpBar();
      $(window).scroll(function () {
        showPdpBar();
      });
      $(window).resize(function () {
        showPdpBar();
      });
    }
  }

  /* Footer newsletter */

  function newsletter(form, additionalFunction) {
    var mailformat = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    var email = form.find('input[type="email"]').val();
    var phone = form.find('input[type="tel"]').val();
    // var phoneTel = form.find('input[type="tel"]').val();
    var checkbox = form.find('input[type="checkbox"]');
    var klaviyoListId = form.find('input[type="email"]').length ? form.find('input[type="email"]').data('klaviyo-id') : form.data('klaviyo-id');
    var title = form.find('input[type="email"]').data('klaviyo-title');
    var origin = '';
    // var data = {
    //   'g': klaviyoListId,
    //   '$fields': '$source,$email,$phone_number,$consent_method,$origin',
    //   '$list_fields': '',
    //   '$timezone_offset': Math.abs(new Date().getTimezoneOffset() / 60),
    //   'SignUpDate': Math.abs(new Date().getTimezoneOffset() / 60),
    //   '$title': (title) ? title : '',
    //   '$source': 'Newsletter',
    //   '$email': (email) ? email : '',
    //   '$phone_number': (phone) ? phone : '',
    //   '$consent_method': 'Klaviyo',
    //   '$origin': origin
    // };

    if (checkbox.length && checkbox.parent().is(':visible')) {
      data['$fields'] += ',$checkbox';
      data['$checkbox'] = form.find('input[type="checkbox"]')[0].checked;
    }

    if (klaviyoListId.length <= 2)  {
      form.find('.Alert--error').removeClass('Hidden')
    }

    let requestAttribute
    if (phone?.length > 10 && email?.match(mailformat)) {
      requestAttribute = {
        email: email,
        phone_number: `+1${phone.replace('(', '').replace(')', '').replace('-', '').replace(' ', '')}`
      }
    } else if (phone?.length > 10) {
      requestAttribute = {
        phone_number: `+1${phone.replace('(', '').replace(')', '').replace('-', '').replace(' ', '')}`
      }
    } else if (email?.match(mailformat)) {
      requestAttribute = {
        email: email
      }
    }

    const options = {
      method: 'POST',
      headers: {revision: '2024-05-15', 'content-type': 'application/json'},
      body: JSON.stringify({
        data: {
          type: 'subscription',
          attributes: {
            custom_source: 'Newsletter',
            profile: {
              data: {
                type: 'profile',
                attributes: requestAttribute
              }
            }
          },
          relationships: {list: {data: {type: 'list', id: klaviyoListId}}}
        }
      })
    };

    if (email?.match(mailformat) || phone?.length > 10) {
      fetch(`https://a.klaviyo.com/client/subscriptions/?company_id=NNXjVm`, options)
        .then(response => {
          if(response.status === 202) {
            form.find('.Form__Input').addClass('Hidden')
            form.find('.Form__Submit').addClass('Hidden')
            form.find('.Alert--success').removeClass('Hidden')
            if(additionalFunction)additionalFunction();
          } else {
            form.find('.Form__Input').addClass('Hidden')
            form.find('.Form__Submit').addClass('Hidden')
            form.find('.Alert--error').removeClass('Hidden')
          }
        })
        .catch(err => console.error(err));


      // $.ajax({
      //   method: 'POST',
      //   headers: {revision: '2024-05-15', 'content-type': 'application/json'},
      //   url: 'https://a.klaviyo.com/client/subscriptions/?company_id=NNXjVm',
      //   data: JSON.stringify({
      //     data: {
      //       type: 'subscription',
      //       attributes: {
      //         custom_source: 'Newsletter',
      //         profile: {
      //           data: {
      //             type: 'profile',
      //             attributes: {
      //               email: email,
      //               attributePhone
      //             }
      //           }
      //         }
      //       },
      //       relationships: {list: {data: {type: 'list', id: klaviyoListId}}}
      //     }
      //   })
      // }).done(function (response) {
      //   if (response.success) {
      //     console.log('success')
      //     if (response.data.is_subscribed) {
      //       form.find('.Form__Input').addClass('Hidden')
      //       form.find('.Form__Submit').addClass('Hidden')
      //       form.find('.AlreadySubscribed').removeClass('Hidden')
      //       if(additionalFunction)additionalFunction();
      //     } else {
      //       form.find('.Form__Input').addClass('Hidden')
      //       form.find('.Form__Submit').addClass('Hidden')
      //       form.find('.Alert--success').removeClass('Hidden')
      //       if(additionalFunction)additionalFunction();
      //     }
      //   }
      // }).fail(function () {
      //   form.find('.Form__Input').addClass('Hidden')
      //   form.find('.Form__Submit').addClass('Hidden')
      //   form.find('.Alert--error').removeClass('Hidden')
      // });
    } else {
      form.find('.Alert--error').removeClass('Hidden')
      setTimeout(() => {
        form.find('.Alert--error').addClass('Hidden')
      }, 3000)
    }
  }

  $(document).on('submit', '#footer-newsletter', function (e) {
    e.preventDefault()
    e.stopPropagation()
    e.stopImmediatePropagation()
    newsletter($(this))
  })

  $(document).on('submit', '#article__sign-up', function (e) {
    e.preventDefault()
    console.log('#article__sign-up')
    newsletter($(this))
  })

  $(document).on('submit', '.landing__hero-content-input-wrapper', function (e) {
    console.log('.landing__hero-content-input-wrapper')
    e.preventDefault()

    const additionalFunction = ()=> {
      const $checbox = $(this).find('.landing__hero-content-checkbox-wrapper');

      if ($checbox) $checbox.addClass('Hidden');

      window.location.href = $(this).data('link-to-page');
    };

    newsletter($(this), additionalFunction)
  })

  function checkEmptyField(input) {
    const $btn =  $('.landing__hero-content-btn')

    setTimeout(()=> {
      if ($(input).val().length > 0) {
        $btn.prop('disabled', false)
      } else {
        $btn.prop('disabled', true)
      }
    },200);
  }

  $(document).on('change keydown', '.landing__hero-content-input', function (e) {
    checkEmptyField(e.target)
  })

  theme.SelectSize = function () {
    var flagClickSize = true;

    function calculateSize() {
      var $thisForm = $(this).parents('form'),
        inputValue = $thisForm.find('input[name=size]').val(),
        size = parseFloat(inputValue),
        $productSizeOption = $thisForm.find('.ProductForm__Option .SizeSwatch__Radio'),
        $productFormMessage = $thisForm.find('.ProductForm__SizeMessage'),
        $productFormRecommendedMessage = $thisForm.find('.ProductForm__RecommendedSizeMessage'),
        recommendedSize = '',
        $pseudoAddToCart = $thisForm.find('.PseudoAddToCart'),
        hasSize = false;
      console.log($productSizeOption)
      $productFormMessage.addClass('Hidden')
      $productFormRecommendedMessage.addClass('Hidden')
      if (inputValue.indexOf(",") >= 0 ) {
        size = parseFloat(inputValue.replace(',', '.'));
      }

      if (size) {
        localStorage.setItem('hat-size', size);
        $productSizeOption.each(function () {
          var minSizeLength = parseFloat($(this).attr('data-min-length'));
          var maxSizeLength = parseFloat($(this).attr('data-max-length'));
          if ((size >= minSizeLength) && (size <= maxSizeLength)) {
            hasSize = true;
            flagClickSize = false;
            recommendedSize = $(this).val();
            $(this).trigger('click')
            $(this).addClass('SizeSwatch__RadioActive')
            $pseudoAddToCart.addClass('Hidden')
            if ($(this).hasClass('SizeSwatch__RadioFalse')) {
              $(this).removeClass('SizeSwatch__RadioFalse')
            }
            $('.ProductForm__AddToCartWrapper').removeClass('Hidden')
            // localStorage.setItem('hat-size', recommendedSize);
            console.log($(this))
          }
          flagClickSize = true;
        })

        if (hasSize) {
          $productFormMessage.addClass('Hidden')
          $productFormRecommendedMessage.html('Your recommended size is ' + '<span>' + recommendedSize.toLowerCase() + '</span>' + ' based on ' + size + 'cm')
          $productFormRecommendedMessage.removeClass('Hidden')
          $('.RecommendedSizeMessage').removeClass('Hidden').text('We recommend size ' + recommendedSize.toLowerCase() + ' for this style')
        } else {
          $productFormMessage.removeClass('Hidden')
          $productFormRecommendedMessage.addClass('Hidden')
        }
      }
    }

    if ($('.SelectSize__Modal').is(':visible')) {
      $('.ProductForm').on('keypress', function (e) {
        if ( e.which == 13 && $('[name=size]').is(':focus')) {
          e.preventDefault();
          // $(this).find('.SelectSize__Modal [data-action="close-drawer"]').trigger('click'); // Close modal
        }
      })
    }

    $('[name=size]').on('keyup change', $.debounce(500, calculateSize));

    if (localStorage.getItem('hat-size') && $('.Product').attr('data-product-type') === 'hat') {
      var storageSizeValue = localStorage.getItem('hat-size'),
          $SizeOption = $('.ProductForm__Option .SizeSwatch__Radio');
          // $storageSize = $('.SizeSwatch__Radio[data-hat-size="' + storageSizeValue + '"]');

      if ($SizeOption.length) {
        $SizeOption.each(function () {
          var minSizeLength = parseFloat($(this).attr('data-min-length'));
          var maxSizeLength = parseFloat($(this).attr('data-max-length'));
          if ((storageSizeValue >= minSizeLength) && (storageSizeValue <= maxSizeLength)) {
            $(this).trigger('click')
            $('[data-radio-size]').removeClass('SizeSwatch__RadioFalse');
            $(this).addClass('SizeSwatch__RadioActive')
            $('.PseudoAddToCart').addClass('Hidden')
            if ($(this).hasClass('SizeSwatch__RadioFalse')) {
              $(this).removeClass('SizeSwatch__RadioFalse')
            }
            $('.ProductForm__AddToCartWrapper').removeClass('Hidden')
            $('.RecommendedSizeMessage').removeClass('Hidden').text('We recommend size ' + $(this).data('hat-size') + ' for this style')
          }
        })
      }

    // if ($storageSize.length) {
    //   $storageSize.trigger('click');
    //   $('[data-radio-size]').removeClass('SizeSwatch__RadioFalse');
    //   $('.ProductForm__AddToCartWrapper').removeClass('Hidden')
    //   $('.PseudoAddToCart').addClass('Hidden')
    // } else {
    //   localStorage.removeItem('hat-size');
    // }
  }

    if ($('.Product').attr('data-product-type') === 'hat') {
      $(document).on('click','.SizeSwatch__Radio', function () {
        if (flagClickSize) {
          $(this).parents('.ProductForm').find('.SelectSize__Modal [data-action="close-drawer"]').trigger('click');
          $('[data-id=' + $(this).data('id') + ']').addClass('SizeSwatch__RadioActive');
          $('.PseudoAddToCart').addClass('Hidden');
        }
      })
    }
  }

  if ($('.SelectSize__Modal').length) {
    theme.SelectSize();
  }

  // Product Image With Text Slider

  function productIwtSlider($slider, slidesToShow, slidesToScroll, $controlsLeft, $controlsRight, $progressBar) {
    $slider.on('init', function(event, slick) {
      var calc = ( 100 / (slick.slideCount) );
      $progressBar
          .css('background-size', calc + '% 100%')
          .attr('aria-valuenow', calc );
    });

    $slider.not('.slick-initialized').slick({
      slidesToShow: slidesToShow,
      slidesToScroll: slidesToScroll,
      dots: false,
      prevArrow: $controlsLeft,
      nextArrow: $controlsRight,
      infinite: true,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            infinite: false
          }
        }
      ]
    });

    $slider.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
      var calc = ( (nextSlide + 1) / (slick.slideCount) ) * 100;
      $progressBar
          .css('background-size', calc + '% 100%')
          .attr('aria-valuenow', calc );
    });
  }

  if ($('.ProductIwtSlider__Images').length) {
    $('.ProductIwtSlider__Images').each(function () {
      var loopItem = $(this).data('forloop-item');
      var $slider = $('.ProductIwtSlider__Images-' + loopItem);
      var $controlsLeft = $('.ProductIwtSlider__ControlsLeft-' + loopItem);
      var $controlsRight = $('.ProductIwtSlider__ControlsRight-' + loopItem);
      var $progressBar = $('.ProductIwtSlider__Progress-' + loopItem);
      productIwtSlider ($slider, 1, 1, $controlsLeft, $controlsRight, $progressBar);
    })
  }

  // Product Influencer Slider

  if ($('.ProductInfluencerSlider__Images').length) {

    function createIgSlider() {
      var $sliderNav = $('.ProductInfluencerSlider__Images'),
          $sliderImages = $('.ProductInfluencerSlider__ImageItem'),
          $sliderFor = $('.ProductInfluencerSlider__linkList'),
          $controls = $('.ProductIwtSlider__Controls'),
          $controlsLeft = $('.ProductIwtSlider__ControlsLeft'),
          $controlsRight = $('.ProductIwtSlider__ControlsRight'),
          $progressBar = $('.ProductInfluencerSlider__Progress');

      if ($sliderImages.length) {
        $('.ProductIwtSlider').removeClass('Hidden')
      }
      if ($sliderImages.length > 1) {
        recommendProductSlider($sliderFor, $sliderNav, 1, 1.5, 1, $controlsLeft, $controlsRight, $progressBar);
        $controls.removeClass('Hidden')
        $progressBar.removeClass('Hidden')
      }
    }

    createIgSlider();

    function getStampedImagesSrc (loadingInterval) {
      var $stampedInstagramMedia = $('.stamped-instagram-media'),
          $IgSlider = $('.ProductInfluencerSlider__Images'),
          $IgLinkListMobile = $('.ProductInfluencerSlider__linkList--Mobile'),
          $IgLinkListDesktop = $('.ProductInfluencerSlider__linkList--Desktop'),
          $isSlickLoaded = (typeof $().slick),
          $stampedReviewsIsLoaded = $('#stamped-reviews-widget').attr('data-loaded-page');

        if ($stampedReviewsIsLoaded && $stampedInstagramMedia.length && $isSlickLoaded) {

           function getUserName (index, element) {
             var username = element.getAttribute('data-username');
             if (username !== '') {
              return  '<a href="https://www.instagram.com/'+ username +'" class="ProductInfluencerSlider__Link Text--small">@'+ username +'</a>'
             } else {
               return  '<a href="https://www.instagram.com/janessaleone/" class="ProductInfluencerSlider__Link Text--small">@janessaleone</a>'
             }
          }

          var filterSrc = (index, element) => element.getAttribute('data-bg').includes('https'),
              getSrc = (index, element) => element.getAttribute('data-bg').split("'")[1].split("?")[0],
              createSlide = (index, element) => '<div class="ProductInfluencerSlider__ImageItem"><img src="' + element + '"/></div>',
              stampedImages = $stampedInstagramMedia.filter(filterSrc).map(getSrc),
              stampedUserNames = $stampedInstagramMedia.filter(filterSrc).map(getUserName),
              stampedSlides = stampedImages.map(createSlide);

          stampedSlides.each(function () {
            $IgSlider.append(this)
          })
          stampedUserNames.each(function () {
            $IgLinkListMobile.append(this)
          })
          stampedUserNames.each(function () {
            $IgLinkListDesktop.append(this)
          })
          if ($IgSlider.is('.slick-initialized')) {
            $IgSlider.slick('unslick');
            $('.ProductInfluencerSlider__linkList').slick('unslick');
          }
          createIgSlider()
          clearInterval(loadingInterval)
        }
      }


      // var mutationObserver = new MutationObserver(function (mutations) {
      //   mutations.forEach(function (mutation) {
      //     var $stampedInstagramMedia = $('.stamped-instagram-media'),
      //         $body = $(mutation.target),
      //         $IgSlider = $('.ProductInfluencerSlider__Images'),
      //         $IgLinkListMobile = $('.ProductInfluencerSlider__linkList--Mobile'),
      //         $IgLinkListDesktop = $('.ProductInfluencerSlider__linkList--Desktop'),
      //         $isSlickLoaded = (typeof $().slick !== 'undefined'),
      //         $stampedReviewsIsLoaded = $('#stamped-reviews-widget').attr('data-loaded-page');
      //       if ($stampedReviewsIsLoaded && $body.find($stampedInstagramMedia).length && uncheck && $isSlickLoaded) {
      //           uncheck = false;
      //
      //          function getUserName (index, element) {
      //            var username = element.getAttribute('data-username');
      //            if (username !== '') {
      //             return  '<a href="https://www.instagram.com/'+ username +'" class="ProductInfluencerSlider__Link Text--small">@'+ username +'</a>'
      //            } else {
      //              return  '<a href="https://www.instagram.com/janessaleone/" class="ProductInfluencerSlider__Link Text--small">@janessaleone</a>'
      //            }
      //         }
      //
      //         var filterSrc = (index, element) => element.getAttribute('data-bg').includes('https'),
      //             getSrc = (index, element) => element.getAttribute('data-bg').split("'")[1].split("?")[0],
      //             createSlide = (index, element) => '<div class="ProductInfluencerSlider__ImageItem"><img src="' + element + '"/></div>',
      //             stampedImages = $stampedInstagramMedia.filter(filterSrc).map(getSrc),
      //             stampedUserNames = $stampedInstagramMedia.filter(filterSrc).map(getUserName),
      //             stampedSlides = stampedImages.map(createSlide);
      //
      //         stampedSlides.each(function () {
      //           $IgSlider.append(this)
      //         })
      //         stampedUserNames.each(function () {
      //           $IgLinkListMobile.append(this)
      //         })
      //         stampedUserNames.each(function () {
      //           $IgLinkListDesktop.append(this)
      //         })
      //         if ($IgSlider.is('.slick-initialized')) {
      //           $IgSlider.slick('unslick');
      //           $('.ProductInfluencerSlider__linkList').slick('unslick');
      //         }
      //         createIgSlider()
      //       }
      //   });
      //
      // });
      // mutationObserver.observe(document.querySelector('body'), {
      //   childList: true,
      //   subtree: true,
      //   attributes: true
      // });
    }

    // if ($('#stamped-reviews-widget').length) {
    //   const loadingInterval = setInterval(() => getStampedImagesSrc(loadingInterval), 50);
    // }

  // Recommend Product Slider

  function recommendProductSlider($sliderFor, $sliderNav, slidesToShowFor, slidesToShow, slidesToScroll, $controlsLeft, $controlsRight, $progressBar) {
    $sliderNav.on('init', function(event, slick) {
      var calc = ( 100 / (slick.slideCount) );
      $progressBar
          .css('background-size', calc + '% 100%')
          .attr('aria-valuenow', calc );
    });

    $sliderFor.slick({
      slidesToShow: slidesToShowFor,
      slidesToScroll: slidesToScroll,
      arrows: false,
      fade: true,
      asNavFor: $sliderNav,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            infinite: false
          }
        }
      ]
    });

    $sliderNav.slick({
      slidesToShow: slidesToShow,
      slidesToScroll: slidesToScroll,
      asNavFor: $sliderFor,
      dots: false,
      prevArrow: $controlsLeft,
      nextArrow: $controlsRight,
      infinite: true,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            infinite: false
          }
        }
      ]
    });

    $sliderNav.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
      var calc = ( (nextSlide + 1) / (slick.slideCount) ) * 100;
      $progressBar
          .css('background-size', calc + '% 100%')
          .attr('aria-valuenow', calc );
    });
  }

  if ($('.ProductRecommendSlider__Products').length) {
    $('.ProductRecommendSlider__Products').each(function () {
      var loopItem = $(this).data('forloop-item');
      var $sliderNav = $('.ProductRecommendSlider__Products-' + loopItem);
      var $sliderFor = $('.ProductRecommendSlider__Text-' + loopItem);
      var $controlsLeft = $('.ProductRecommendSlider__ControlsLeft-' + loopItem);
      var $controlsRight = $('.ProductRecommendSlider__ControlsRight-' + loopItem);
      var $progressBar = $('.ProductRecommendSlider__Progress-' + loopItem);
      recommendProductSlider($sliderFor, $sliderNav, 1, 1, 1, $controlsLeft, $controlsRight, $progressBar);
    })
  }

  if ($('#create_customer').length) {
    var $createCustomerForm = $('#create_customer');
    var $email = $createCustomerForm.find('input[type="email"]');
    var $password = $createCustomerForm.find('input[type="password"]');

    function ValidateEmail(email) {
      if (/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(email.val())) {
        return true;
      }
      return false
    }

    function ValidatePassword(password) {
      if (password.val().length > 4) {
        return true;
      }
      return false
    }

    $createCustomerForm.find('input').on('keyup', function () {
      var $input = $createCustomerForm.find('input.Form__Input[required]');
      var inputLength = $createCustomerForm.find('input.Form__Input[required]').length;
      var inputNotEmpty = 0;

      $input.each(function() {
        if (!!$(this).val()) {
          inputNotEmpty++
        }
      });

      if (inputLength == inputNotEmpty && ValidateEmail($email) && ValidatePassword($password)) {
        $createCustomerForm.find('button[type="submit"]').attr('disabled', false);
        $createCustomerForm.find('button[type="submit"]').removeClass('Button--error');
        $createCustomerForm.find('input.Form__Input.Form__Input--Alert[required]').removeClass('Form__Input--Alert');
      } else {
        $createCustomerForm.find('button[type="submit"]').attr('disabled', true);
      }
    });
  }

  if ($('#addNewForm').length) {
    var $addNewForm = $('#addNewForm');

    $addNewForm.find('input').on('keyup', function () {
      var $input = $addNewForm.find('input.Form__Input[required]');
      var inputLength = $addNewForm.find('input.Form__Input[required]').length;
      var inputNotEmpty = 0;

      $input.each(function() {
        if (!!$(this).val()) {
          inputNotEmpty++
        }
      });

      if (inputLength == inputNotEmpty) {
        $addNewForm.find('button[type="submit"]').attr('disabled', false);
        $addNewForm.find('button[type="submit"]').removeClass('Button--error');
        $addNewForm.find('input.Form__Input.Form__Input--Alert[required]').removeClass('Form__Input--Alert');
      } else {
        $addNewForm.find('button[type="submit"]').attr('disabled', true);
      }
    });
  }

  if ($('#reset_customer_password').length) {
    var $resetCustomerPassword = $('#reset_customer_password');

    $resetCustomerPassword.find('input').on('keyup', function () {
      var $input = $resetCustomerPassword.find('input.Form__Input[required]');
      var inputLength = $resetCustomerPassword.find('input.Form__Input[required]').length;
      var inputNotEmpty = 0;

      $input.each(function() {
        if (!!$(this).val()) {
          inputNotEmpty++
        }
      });

      if (inputLength == inputNotEmpty) {
        $resetCustomerPassword.find('button[type="submit"]').attr('disabled', false);
        $resetCustomerPassword.find('button[type="submit"]').removeClass('Button--error');
        $resetCustomerPassword.find('input.Form__Input.Form__Input--Alert[required]').removeClass('Form__Input--Alert');
      } else {
        $resetCustomerPassword.find('button[type="submit"]').attr('disabled', true);
      }
    });
  }

  // Search

  $('[data-search] button').addClass('disabled')
  $('[data-search] input').on('keyup keydown keypress change paste', function() {
    ($(this).val() === '')
        ? $('[data-search] button').addClass('disabled')
        : $('[data-search] button').removeClass('disabled')
  });

  function checkSearch () {
    var uncheck = true;
    var mutationObserver = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        var $recProducts = $('.SearchBar__PopularSearches');
        var $body = $(mutation.target);

        if ($('.SearchBox').is(':visible')) {
          if ($body.hasClass('snize-instant-widget-is-open') && uncheck) {
            uncheck = false;
            $recProducts.fadeOut(0)
            $('.snize-ac-results').attr('data-scrollable', '')
          } else if (!$body.hasClass('snize-instant-widget-is-open') && !uncheck) {
            uncheck = true
            $recProducts.fadeIn(300)
            $('.snize-ac-results').removeAttr('data-scrollable', '')
          }
        }
      });
    });
    mutationObserver.observe(document.querySelector('body'), {
      attributes: true
    });
  }
  checkSearch();

  /* Review app */

  function checkReview () {
    var mutationObserverReview = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        var $body = $(mutation.target);

        if ($('.Review__Modal').is(':visible')) {
          if ($body.hasClass('AdditionalReviews')) {
            var $reviewTextarea =  $('.stamped-form-review-body .stamped-form-input textarea'),
                reviewTextareaPh = 'Tell people if you woud recommend this product and what you like or dislike about it.',
                $nameInput = $('.stamped-form-contact .stamped-form-contact-name input'),
                nameInputPh = 'First Name',
                $mailInput = $('.stamped-form-contact .stamped-form-contact-email input'),
                mailInputPh = 'Email Address',
                $reviewSubmitBtn = $('.new-review-form #stamped-button-submit'),
                $reviewTitle = $('input[name="reviewTitle"]');

            $reviewSubmitBtn.addClass('Button Button--secondary').attr('disabled', 'disabled');
            $reviewTitle.val('Review')

            var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            var scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;
            window.onscroll = function () {
              window.scrollTo(scrollLeft, scrollTop);
            };

            function changePlaceholder($element, placeholderText) {
              if(!$element.val()) {
                $element.attr("placeholder", placeholderText);
              }
            }

            function checkInputValue() {
              if ($reviewTextarea.val() && $nameInput.val() && $mailInput.val()) {
                $reviewSubmitBtn.removeClass('Button--secondary');
                $reviewSubmitBtn.addClass('Button--primary');
                $reviewSubmitBtn.removeAttr('disabled');
              } else {
                $reviewSubmitBtn.removeClass('Button--primary');
                $reviewSubmitBtn.addClass('Button--secondary').attr('disabled', 'disabled');
              }
            }

            checkInputValue()

            changePlaceholder($reviewTextarea, reviewTextareaPh)
            changePlaceholder($nameInput, nameInputPh)
            changePlaceholder($mailInput, mailInputPh)

            $(document).on('change keyup', $reviewTextarea, checkInputValue)
            $(document).on('change keyup', $nameInput, checkInputValue)
            $(document).on('change keyup', $mailInput, checkInputValue)
          } else {
            window.onscroll = function() {};
          }
        }
      });
    });
    mutationObserverReview.observe(document.querySelector('body'), {
      attributes: true
    });
  }
  checkReview();

  if ($('.Blog__Container').length) {
    function blogSlider($sliderFor, $sliderNav, slidesToShowFor, slidesToScroll, $controlsLeft, $controlsRight, $progressBar, slidesToShow) {
      $sliderNav.on('init', function(event, slick) {
        var calc = ( 100 / (slick.slideCount) );
        $progressBar
          .css('background-size', calc + '% 100%')
          .attr('aria-valuenow', calc );
      });

      $sliderFor.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        prevArrow: $controlsLeft,
        nextArrow: $controlsRight,
        fade: true,
        infinite: true,
        asNavFor: $sliderNav,
        responsive: [
          {
            breakpoint: 640,
            settings: {
              infinite: false,
              centerPadding: '0px',
              centerMode: true,
              adaptiveHeight: true
            }
          }
        ]
      });

      $sliderNav.slick({
        slidesToShow: slidesToShow,
        slidesToScroll: 1,
        asNavFor: $sliderFor,
        dots: false,
        arrows: false,
        infinite: true,
        centerPadding: '0px',
        centerMode: true,
        responsive: [
          {
            breakpoint: 640,
            settings: {
              slidesToShow: 1,
              infinite: false
            }
          }
        ]
      });

      $sliderNav.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
        var calc = ( (nextSlide + 1) / (slick.slideCount) ) * 100;
        $progressBar
          .css('background-size', calc + '% 100%')
          .attr('aria-valuenow', calc );
      });
    }

    if ($('.BlogSlider__Images').length) {
      $('.BlogSlider__Images').each(function () {
        var loopItem = $(this).data('forloop-item');
        var $sliderNav = $('.BlogSlider__Images-' + loopItem);
        var $sliderFor = $('.BlogSlider__Content-' + loopItem);
        var $controlsLeft = $('.BlogSlider__ControlsControlsLeft-' + loopItem);
        var $controlsRight = $('.BlogSlider__ControlsControlsRight-' + loopItem);
        var $progressBar = $('.BlogSlider__ImagesProgress-' + loopItem);
        var slidesToShow
        var imageLenght = $('.BlogSlider__ImagesItem').length
        if (imageLenght <= 4) {
          slidesToShow = imageLenght - 1
        } else  {
          slidesToShow = 3
        };

        blogSlider($sliderFor, $sliderNav, 1,1, $controlsLeft, $controlsRight, $progressBar, slidesToShow);
      })
    }

    $(document).on('click', '.Blog__TagList a', function (event) {
      event.preventDefault()
      var $tab = $('.Blog__TagList a')
      var $othersTab = $tab.not(this)
      var ajaxUrl = $(this).attr('href');
      var url = ajaxUrl.split('?view=ajax')[0];
      var $button = $('.Article__ButtonView');
      $button.slideDown(300);

      var newurl = window.location.protocol + '//' + window.location.host + url;
      window.history.replaceState({ path: newurl }, '', newurl);
      window.history.pushState({ path: newurl }, '', newurl);

      $(this).addClass('is-active');
      $othersTab.removeClass('is-active');
      ajaxRequest($button, ajaxUrl)

      $.ajax({
        url: ajaxUrl,
        method: 'GET',
        success: function (data) {
          var $articlesWrapper = $('.Articles__Wrapper');
          var $itemsWrapperHtml = $(data).find('.Articles__Wrapper').html();
          $articlesWrapper.html($itemsWrapperHtml);
        }
      });
    })

    window.onpopstate = function(event) {
      var ajaxUrlBack = event.state.path;
      var tag = ajaxUrlBack.split('/');
      var tagLast = tag.length - 2;
      var currentTag = tag[tagLast] ;

      $.ajax({
        url: ajaxUrlBack,
        method: 'GET',
        success: function (data) {
          var $articlesWrapper = $('.Articles__Wrapper');
          var $articlesBtn = $('.Article__Button');
          var $itemsWrapperHtml = $(data).find('.Articles__Wrapper').html();
          var $articlesBtnHtml = $(data).find('.Article__Button').html();
          $articlesWrapper.html($itemsWrapperHtml);
          $articlesBtn.html($articlesBtnHtml);
          var $filtersTag = $('.Articles__Wrapper').parents('.Blog__Container').find('.Heading ')
          $filtersTag.removeClass('is-active');
          $('[data-article-tag=' + currentTag + ']').addClass('is-active');
        }
      });
    };

    $(document).on('click', '.Article__ButtonView', function (event) {
      event.preventDefault();
      var $button = $(this);
      var ajaxUrl = $(this).attr('href');

      ajaxRequest($button, ajaxUrl)
    });

    function ajaxRequest ($button, ajaxUrl) {
      $.ajax({
        url: ajaxUrl,
        method: 'GET',
        success: function (data) {
          var $itemsWrapper = $(data).find('.ArticleList');
          var nextPageUrl = $itemsWrapper.attr('data-next-page-url');

          if (!nextPageUrl) {
            $button.slideUp(300);
          }
          $button.attr('href', nextPageUrl);
          $button.parents('.Blog__Container').find('.ArticleListWrapper').append($itemsWrapper);
        }
      });
    }
  }

  if ($('.SupportContactForm').length) {
    $('.SupportContactForm').on('submit', function (e) {
      var $alert_success = $(".SupportContactForm .Alert--success");
      e.preventDefault()
      $alert_success.removeClass("Hidden")
      setTimeout(function () {
        $alert_success.addClass("Hidden")
        e.currentTarget.submit();
      }, 3000)
    })
  }

  theme.pdpVariantVideo = function () {
    var $variantVideos = $(document).find('.pdp-video');

    function checkLoad(video) {
      if (video[0].readyState === 4) {
        // video.parent().css('paddingBottom', (100 / 0.8) + '%')
      } else {
        setTimeout(checkLoad, 100, video);
      }
    }

    $variantVideos.each(function () {
      checkLoad($(this));
    })
  }

  if ($('.pdp-video').length) {
    theme.pdpVariantVideo()
  }

  theme.SearchResultPage = function () {
    function changePaginationChangeImageSize () {
      var changePagination = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {

          if (mutation.addedNodes.length) {
            var $resultImage = $('#snize-search-results-grid-mode span.snize-thumbnail img');

            $resultImage.each(function () {
              let newImageSize = $(this).attr('src').replace('_large.jpg', '_800x.jpg');
              $(this).attr('src', newImageSize);
            })
          }
        })
      });

      changePagination.observe(document.querySelector('.snize-search-results-content'), {
        childList: true
      });
    }

    function pageLoadChangeImageSize () {
      var pageLoad = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          var $resultImage = $('#snize-search-results-grid-mode span.snize-thumbnail img');

          if ($resultImage.length > 0) {
            $resultImage.each(function () {
              let newImageSize = $(this).attr('src').replace('_large.jpg', '_800x.jpg');
              $(this).attr('src', newImageSize);
            })

            pageLoad.disconnect();
            changePaginationChangeImageSize();
          }
        })
      });

      pageLoad.observe(document.querySelector('body'), {
        attributes: true
      });
    }

    pageLoadChangeImageSize();
  }

  if ($('body').hasClass('snize-results-page')) {
    theme.SearchResultPage();
  }

  /* Size guide */

  function videoSlider (slider, progressLine) {
    slider.on('init', function(event, slick) {
      var calc = ( 100 / (slick.slideCount) );
      progressLine
          .css('background-size', calc + '% 100%')
          .attr('aria-valuenow', calc );
    });

    slider.not('.slick-initialized').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: false,
      arrows: false,
      infinite: false,
      autoplay: false
    });

    slider.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
      var calc = ( (nextSlide + 1) / (slick.slideCount) ) * 100;
      progressLine
          .css('background-size', calc + '% 100%')
          .attr('aria-valuenow', calc );
    });
  }

  if ($('.SizeGuideVideoSlider').length) {
    var sectionId = $('.SizeGuideVideoSlider').attr('id'),
        $slider = $('.SizeGuideVideoSlider-' + sectionId),
        $progressLine = $('.SizeGuideVideoSlider-ProgressLine-' + sectionId);
    videoSlider($slider, $progressLine)
  }

  function sizeGuideCalculator (input) {
    var $thisCalculator = input.parents('.ProductForm__Size'),
        inputValue = $thisCalculator.find('input[name=size]').val(),
        size = parseFloat(inputValue),
        $sizeRange = input.parents('.SizeGuideMeasurement__Wrapper').find('.SizeGuideMeasurement__TableRow'),
        $messageError = $thisCalculator.find('.SizeGuideMeasurement__Message-error'),
        $recommendedMessage = $thisCalculator.find('.SizeGuideMeasurement__Message-recommended'),
        $sizeGuideLink = $thisCalculator.find('.SizeGuideMeasurement__SizeLink'),
        recommendedSize = '',
        hasSize = false;
    $messageError.addClass('Hidden')
    $recommendedMessage.addClass('Hidden')
    $sizeGuideLink.addClass('Link--disabled')
    if (inputValue.indexOf(",") >= 0 ) {
      size = parseFloat(inputValue.replace(',', '.'));
    }
    if (size) {
      localStorage.setItem('hat-size', size);
      $sizeRange.each(function () {
        var minSizeValue = parseFloat($(this).data('min-value'));
        var maxSizeValue = parseFloat($(this).data('max-value'));
        if ((size >= minSizeValue) && (size <= maxSizeValue)) {
          hasSize = true
          recommendedSize = $(this).data('size')
          return false
        }
      })

      if (hasSize) {
        $recommendedMessage.html('Your recommended size is ' + '<span>' + recommendedSize.toLowerCase() + '</span>' + ' based on ' + size + 'cm')
        $sizeGuideLink.attr('href', '/collections/all/?sort_by=manual&size=' + recommendedSize.toLowerCase() + '&availability=true').text('View all ' + recommendedSize.toLowerCase() + ' hats')
        $recommendedMessage.removeClass('Hidden')
        $sizeGuideLink.removeClass('Link--disabled')
      } else {
        $messageError.removeClass('Hidden')
        $recommendedMessage.addClass('Hidden')
      }
    }
  }

  if ($('.SizeGuideMeasurement__SizeWrapper').length) {
    var $sizeInput = $('.SizeGuideMeasurement__SizeWrapper').find('input[name=size]')

    $sizeInput.on('keypress', function (e) {
      if ( e.which === 13 && $sizeInput.is(':focus')) {
        e.preventDefault();
        sizeGuideCalculator($(this));
      }
    })
  }

  // Care page
  if ($('[data-care-links]').length) {
    $(document).on('mouseenter', '.CareNavigation__Mainlinks', function() {
      let $linksToShow = $('[data-care-sublinks="'+ $(this).data('care-links') +'"]'),
          $childLinkTitle = $linksToShow.find('[data-care-sublinks-parent]:first').data('care-sublinks-parent'),
          $subLinksToShow = $('[data-care-sublinks-child="'+ $childLinkTitle +'"]');
      $('[data-care-sublinks]').hide();
      $('[data-care-sublinks-child]').hide();
      if ($linksToShow.length) {
        $linksToShow.show();
      }
      if ($subLinksToShow.length) {
        $subLinksToShow.show();
      }
    })
  }

  if ($('[data-care-sublinks-parent]').length) {
    $(document).on('mouseenter', '.CareNavigation__Sublinks', function() {
      let $childLinkToShow = $('[data-care-sublinks-child="'+ $(this).data('care-sublinks-parent') +'"]');
      $('[data-care-sublinks-child]').hide();
      if ($childLinkToShow.length) {
        $childLinkToShow.show();
      }
    })
  }

});